import React from 'react'
import PropTypes from 'prop-types'

function Title({ className, children }) {
  return (
    <h1
      className={
        className ? `${className} heading-main heading-main-bold` : 'heading-main heading-main-bold'
      }
    >
      {children}
    </h1>
  )
}

Title.defaultProps = {
  className: 'heading-main heading-main-bold'
}

Title.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

export default Title
